import { AppDispatch } from '../../../store'
import { setOpenEventDetails } from '../../store/calendarSlice'
import { IEmptySlotClick } from '../../types'

export const createEvent = (
  lastEmptySlotClick: IEmptySlotClick,
  dispatch: AppDispatch,
) => {
  dispatch(
    setOpenEventDetails({
      openFormDetails: {
        type: 'create_appointment',
        event: {
          startsAt: lastEmptySlotClick.clickedMoment,
          selectedPerson: lastEmptySlotClick.person,
        },
      },
    }),
  )
}
